import React from 'react';

const SlackChannelRequireAllTags = (props: $FIXME) => {
  return (
    <>
      <div className="item-option-container">
        <label>Require all tags: </label>
        <div className="tier-statuses-container">
          <label>
            <input type="checkbox" checked={!!props.channel.requireAllTags} disabled={true} />
          </label>
        </div>
      </div>
      <style>{`
        label {
          font-weight: 500;
          padding-right: 4px;
        }
        .tier-statuses-container {
          display: flex;
          flex-wrap: wrap;
          max-width: 300px;
          margin-left: 8px;
        }
        .tier-status-box-container {
          border-radius: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 4px;
          border: 1px solid var(--color-RemoGray50);
        }
        .tier-status-box {
          padding: 4px 12px;
          white-space: nowrap;
        }
        .item-option-container {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      `}</style>
    </>
  );
};

export default SlackChannelRequireAllTags;
